import { SET_CLIENT_DASHBOARD } from "../constants/clientConstants";
import { saveClientDashboardState } from "../utils/localStorageUtils";

export const clientDashboardPersistMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    // Check if the action affects the client dashboard state
    if (action.type === SET_CLIENT_DASHBOARD) {
      const state = store.getState();
      // Save only the clientDashboard slice
      saveClientDashboardState(state.clientDashboardReducer.selectedClient);
    }
    return result;
  };